export const systemRoleTypes = [
  { label: "Administrador", value: "SUPER_ADMIN" },
  { label: "Coordinador", value: "COORDINATOR" },
  { label: "Emprendedor", value: "ENTREPRENEUR" },
  { label: "Experto", value: "ADVISER" }
];
